var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo_symbol-a",
    d: "M17.381129,2.37410753 L2.46096774,16.9646022 C-0.348387097,19.7096344 -0.348387097,24.2018925 2.46096774,26.9469247 L2.46096774,26.9469247 L17.381129,41.5374194 C20.19,44.2815054 24.783871,44.2815054 27.5922581,41.5355269 L27.5922581,41.5355269 L42.5129032,26.9473978 C45.3208065,24.2018925 45.3208065,19.7096344 42.5129032,16.964129 L42.5129032,16.964129 L27.5922581,2.37458065 C26.1880645,1.0015914 24.3377419,0.315096774 22.4869355,0.315569648 L22.4869355,0.315569648 C20.636129,0.315569648 18.7853226,1.00206452 17.381129,2.37410753 L17.381129,2.37410753 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_symbol-c",
    d: "M17.381129,2.37410753 L2.46096774,16.9646022 C-0.348387097,19.7096344 -0.348387097,24.2018925 2.46096774,26.9469247 L2.46096774,26.9469247 L17.381129,41.5374194 C20.19,44.2815054 24.783871,44.2815054 27.5922581,41.5355269 L27.5922581,41.5355269 L42.5129032,26.9473978 C45.3208065,24.2018925 45.3208065,19.7096344 42.5129032,16.964129 L42.5129032,16.964129 L27.5922581,2.37458065 C26.1880645,1.0015914 24.3377419,0.315096774 22.4869355,0.315569648 L22.4869355,0.315569648 C20.636129,0.315569648 18.7853226,1.00206452 17.381129,2.37410753 L17.381129,2.37410753 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_symbol-e",
    d: "M17.381129,2.37410753 L2.46096774,16.9646022 C-0.348387097,19.7096344 -0.348387097,24.2018925 2.46096774,26.9469247 L2.46096774,26.9469247 L17.381129,41.5374194 C20.19,44.2815054 24.783871,44.2815054 27.5922581,41.5355269 L27.5922581,41.5355269 L42.5129032,26.9473978 C45.3208065,24.2018925 45.3208065,19.7096344 42.5129032,16.964129 L42.5129032,16.964129 L27.5922581,2.37458065 C26.1880645,1.0015914 24.3377419,0.315096774 22.4869355,0.315569648 L22.4869355,0.315569648 C20.636129,0.315569648 18.7853226,1.00206452 17.381129,2.37410753 L17.381129,2.37410753 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "logo_symbol-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo_symbol-a"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "43.147 26.16 26.203 9.592 30.575 5.318 47.519 21.886",
    mask: "url(#logo_symbol-b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "logo_symbol-d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo_symbol-c"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "22.483 6.086 18.119 1.82 22.491 -2.454 26.854 1.812",
    mask: "url(#logo_symbol-d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "logo_symbol-f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo_symbol-e"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "39.36 29.862 34.988 25.588 22.529 37.77 6.36 21.737 18.705 9.667 14.333 5.392 2.019 17.431 1.953 17.365 -2.42 21.641 22.514 46.366 26.885 42.091 26.871 42.076",
    mask: "url(#logo_symbol-f)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbol);
export default __webpack_public_path__ + "static/media/logo-symbol.7efc4a267f5a5c971c6afd800767d1f4.svg";
export { ForwardRef as ReactComponent };